import { useMutation } from "@tanstack/react-query";
import FetchClients, { ClientOutput } from "../client";
import {
  recursiveCamelCaseCipher,
  recursiveSnakeCaseCipher,
} from "@src/global_functions/postgrestApi";
import { CamelCasedPropertiesDeep } from "type-fest";
import { throwErrorWithHelpText } from "./errors";

export type UserInformationRequestBodySnakeCase =
  ClientOutput["rewards"]["UserInfoRequest"];
export type UserInformationRequestBody =
  CamelCasedPropertiesDeep<UserInformationRequestBodySnakeCase>;
export type UserInformationResponse =
  ClientOutput["rewards"]["UserInfoResponse"];
type CamelCaseResponse = CamelCasedPropertiesDeep<UserInformationResponse>;

const userInformation = {
  mutations: { usePostUserInformation },
} as const;

export default userInformation;

const postUserInformation = async (body: UserInformationRequestBody) => {
  const { data, error } = await FetchClients.rewards.POST("/user-information", {
    body: recursiveSnakeCaseCipher(body),
  });
  if (data) return recursiveCamelCaseCipher(data) as CamelCaseResponse;
  throwErrorWithHelpText(error);
};

function usePostUserInformation() {
  return useMutation({
    mutationFn: (body: UserInformationRequestBody) => postUserInformation(body),
  });
}
